import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  ERR_PROCESSING_REQ,
  SAVE_SUCCESS,
} from '../../../../SharedModules/AppConstants';

export const dispatchPriceTypeDetails = (payload) => ({
  type: actionTypes.GET_PRICETYPE_DATA,
  payload,
});

export const dispatchComparePriceTypeDetails = (payload) => ({
  type: actionTypes.COMPARE_PRICE_TYPE_DATA,
  payload,
});

export const setPriceTypeLoading = (payload) => ({
  type: actionTypes.PRICE_TYPE_DATA_LOADING,
  payload,
});

export const setPriceTypeErrorMessage = (payload) => ({
  type: actionTypes.PRICE_TYPE_ERROR_MESSAGE,
  payload,
});

export const setPriceTypeSuccessMessage = (payload) => ({
  type: actionTypes.PRICE_TYPE_SUCCESS_MESSAGE,
  payload,
});

export const setPriceTypeDataChangeTried = (payload) => ({
  type: actionTypes.PRICE_TYPE_DATA_CHANGE_TRIED,
  payload,
});
export const resetPriceTypeStore = () => ({
  type: actionTypes.RESET_PRICETYPE_STORE,
});

export const DummyUpdateAndDelete = () => {
  return (dispatch, getState) => {
    let currentData = [
      ...getState().sharedState?.PriceTypeReducer?.rebatePriceSerchResult,
    ];

    currentData.push({});

    dispatch(dispatchPriceTypeDetails(currentData));

    currentData = currentData.filter((item) => item.priceTypeCd);

    dispatch(dispatchPriceTypeDetails(currentData));
  };
};

export const GetAndDispatchPriceTypeDetails = (func) => {
  return async (dispatch) => {
    dispatch(setPriceTypeLoading(true));
    const response = await getPriceTypeDetailsAPI({});
    if (response) {
      const newResponse = response.map((item, index) => {
        return {
          ...item,
          allowEntryInd: !item.allowEntryInd ? 0 : item.allowEntryInd,
          index,
        };
      });

      dispatch(dispatchPriceTypeDetails(newResponse));
      dispatch(dispatchComparePriceTypeDetails(_.cloneDeep(newResponse)));
      dispatch(DummyUpdateAndDelete());
      dispatch(setPriceTypeErrorMessage(''));
    } else {
      dispatch(dispatchPriceTypeDetails([]));
      dispatch(dispatchComparePriceTypeDetails([]));
      dispatch(setPriceTypeErrorMessage(ERR_PROCESSING_REQ));
    }

    if (func) {
      func();
    } else {
      dispatch(setPriceTypeSuccessMessage(''));
    }

    dispatch(setPriceTypeLoading(false));
  };
};

export const updatePriceTypeDetails = (values, func) => {
  return async (dispatch) => {
    const response = await updatePriceTypeDetailsAPI(values);
    if (response) {
      dispatch(
        GetAndDispatchPriceTypeDetails(() => {
          if (func) {
            func();
          }

          dispatch(setPriceTypeSuccessMessage(SAVE_SUCCESS));
        })
      );
    } else {
      dispatch(setPriceTypeSuccessMessage(''));
      dispatch(setPriceTypeErrorMessage(ERR_PROCESSING_REQ));
    }
  };
};

export const getPriceTypeDetailsAPI = async (values) => {
  try {
    const response = await axios.get(
      serviceEndPoint.GET_PRICETYPE_DATA,
      values
    );

    if (response.data && response.data.data && response.data.data.length > 0) {
      return response.data.data;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const updatePriceTypeDetailsAPI = async (values) => {
  try {
    await axios.post(serviceEndPoint.UPDATE_PRICETYPE_DATA, values);
    return 'Success';
  } catch (e) {
    return null;
  }
};
export const clearReduxPriceTypeScreen = () => (dispatch) => {
  dispatch(setPriceTypeSuccessMessage(''));
  dispatch(setPriceTypeErrorMessage([]));
  dispatch(dispatchPriceTypeDetails([]));
  dispatch(dispatchComparePriceTypeDetails([]));
  dispatch(setPriceTypeLoading(false));
};
